
import {
  IconChargingWire,
  IconSmartphone,
  IconWarning,
  RevInfoBlock,
  RevLink,
  RevList,
  RevListItem,
  RevModal,
} from '@backmarket/design-system'
import isEmpty from 'lodash/isEmpty'

import { MODAL_NAMES } from '@config/constants'

import translations from './TechSpecModal.translations'

const ICONS = {
  iphone: IconSmartphone,
  charging_cable: IconChargingWire,
}

export default {
  components: {
    RevLink,
    RevModal,
    RevList,
    RevListItem,
    RevInfoBlock,
  },
  props: {
    technicalSpecifications: {
      type: Object,
      required: true,
    },
  },
  computed: {
    modalName: () => MODAL_NAMES.PRODUCT.TECH_SPECS,
    translations: () => translations,
    iconWarning: () => IconWarning,
    showProductAccessories() {
      return !isEmpty(this.technicalSpecifications.providedWithProduct)
    },
    accessoriesBlockTitle() {
      return (
        this.technicalSpecifications.providedWithProduct &&
        this.technicalSpecifications.providedWithProduct.title
      )
    },
    accessoriesBlockParagraphs() {
      return (
        this.technicalSpecifications.providedWithProduct &&
        this.technicalSpecifications.providedWithProduct.texts.join(' ')
      )
    },
    accessoriesBlockLink() {
      return (
        this.technicalSpecifications.providedWithProduct &&
        this.technicalSpecifications.providedWithProduct.hyperlink
      )
    },
    accessoriesDetails() {
      return (
        this.technicalSpecifications.providedWithProduct &&
        this.technicalSpecifications.providedWithProduct.rows.map(
          ({ icon, text }) => {
            return {
              icon: ICONS[icon],
              text,
            }
          },
        )
      )
    },
    showAccessoriesBlockLink() {
      return !isEmpty(
        this.technicalSpecifications.providedWithProduct.hyperlink,
      )
    },
    showReassurancesBlocks() {
      return !isEmpty(this.technicalSpecifications.reassurances)
    },
    reassurances() {
      return this.technicalSpecifications.reassurances
    },
    showSpecifications() {
      return !isEmpty(this.technicalSpecifications.specifications)
    },
    specifications() {
      return this.technicalSpecifications.specifications
    },
    showAdditionalInfo() {
      return !isEmpty(this.technicalSpecifications.additionalInfo)
    },
    additionalInfo() {
      return this.technicalSpecifications.additionalInfo
    },
    showWarnings() {
      return !isEmpty(this.technicalSpecifications.warnings)
    },
    warnings() {
      return this.technicalSpecifications.warnings
    },
  },
}
